'use strict';

/*
 * Module `app.resources` initializes the saturn data boosters (resources) with
 * the needed configuration, provided by the IdentityService.
 * Require it as part of the very initialization process to ensure other modules
 * have them already initialized
 */
angular.module('app.resources', ['common.identity', 'saturn.data', 'pubnub.angular.service'])
.run(['IdentityService', 'ResourceHelper', 'Pubnub', '$rootScope',
  function(IdentityService, ResourceHelper, Pubnub, $rootScope) {
    var resourceNames = [
      'Site',
      'DataCapture',
      'DataExport',
      'Annotation',
      'AnnotationLayer',
      'Overlay',
      'Measurement',
      'User',
      'Project',
      'ProjectUser',
      'Group',
      'Invitation',
      'Organization',
      'OrganizationUser',
      'OrganizationProject',
      'Plan',
      'ProcessingJob'
    ];

    var identityConfig = {
      apiBaseUri: IdentityService.getApiUri(),
      fbBaseUri: IdentityService.getFirebaseUri('apollo'),
      fbAuthToken: IdentityService.getFirebaseToken('apollo')
    };

    resourceNames.forEach(function(resourceName) {
      ResourceHelper.initialize(resourceName, identityConfig);
    });
  }
]);



// WEBPACK FOOTER //
// ./src/app/resources/index.js